import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangePurchaseNetPriceCurrencyCommand extends BaseCommand {
  CommandName = "ChangePurchaseNetPriceCurrency";
  Command: {
    Currency: string;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, currency: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Currency: currency };
  }
}
